import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { connectAuthPost, getConnectToken, clearConnectSession } from './connectApi';
import ConnectShell from './ConnectShell';
import './styles/ConnectGroups.css';

/**
 * The list of groups. The set is fixed and managed from the dashboard, so
 * there is no "create a group" here.
 */
export default function ConnectGroups() {
  const navigate = useNavigate();
  const [groups, setGroups] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!getConnectToken()) {
      navigate('/connect');
      return undefined;
    }
    let cancelled = false;
    const load = async () => {
      try {
        const result = await connectAuthPost('connect/groups/list');
        if (cancelled) return;
        if (result.success) setGroups(result.data.groups || []);
        else setError(result.response || 'Could not load the groups.');
      } catch (err) {
        if (!cancelled) setError('Could not reach the server.');
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };
    load();
    return () => { cancelled = true; };
  }, [navigate]);

  const handleLogout = async () => {
    try { await connectAuthPost('connect/auth/logout'); } catch (err) { /* clear locally regardless */ }
    clearConnectSession();
    navigate('/connect');
  };

  return (
    <ConnectShell active="groups" onLogout={handleLogout}>
      <h1 className="groups-title">Groups</h1>

      {error && <p className="feed-error">{error}</p>}
      {isLoading && <div className="cpx-state"><h3>Loading groups</h3></div>}
      {!isLoading && !error && groups.length === 0 && (
        <div className="cpx-state"><h3>Groups are coming soon</h3></div>
      )}

      <div className="groups-grid">
        {groups.map((group) => (
          <Link key={group.id} to={`/connect/groups/${group.id}`} className="group-card">
            <div
              className="group-card-image"
              style={group.image ? { backgroundImage: `url(${group.image})` } : undefined}
            />
            <div className="group-card-body">
              <h2>{group.name}</h2>
              <span className="group-card-meta">
                {group.member_count} member{group.member_count === 1 ? '' : 's'}
                {group.is_member && ' · Joined'}
              </span>
              {group.description && <p>{group.description}</p>}
            </div>
          </Link>
        ))}
      </div>
    </ConnectShell>
  );
}
